import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import TermItemSelect from './TermItemSelect';

type TermItemField = 'id' | 'name' | 'value' | 'value2' | 'value3';

interface Props extends BaseFieldProps {
	termType: string;
	labelFrom?: TermItemField;
	valueFrom?: TermItemField;
	/** Template for label, e.g. '{value} - {name}'. Placeholders: {id}, {name}, {value}, {value2}, {value3} */
	labelFormat?: string;
}

const TermItemSelectField: React.FC<Props> = ({
	termType,
	labelFrom,
	valueFrom,
	labelFormat,
	...baseProps
}) => (
	<BaseField {...baseProps}>
		<TermItemSelect
			termType={termType}
			returnKey='value'
			labelFrom={labelFrom}
			valueFrom={valueFrom}
			labelFormat={labelFormat}
		/>
	</BaseField>
);

export default TermItemSelectField;
